<template>
    <div class="ndiv ht345 br2 bgw br5 tleft">
      {{type}}
      <div class="est mb20 pl10 pt15 ml5 mr5">
        <router-link :to="{path: `${more}/index`}" class="fr tc9 fs14 mr10 mt10 hc-blue">
          更多&gt;&gt;
        </router-link>
        <div class="sts fs24 tcenter cpointer dinline-block pb5 active">
          <!-- <span class="tc">通知</span>公告 -->
          <slot></slot>
        </div>
      </div>
      <div class="cont pl20 pr15">
        <div v-for="(item, index) in cont" :key="item.id"
          @click="goDetail(`${more}/detail?id=${item.id}`)"
          class="fs15 nt cpointer ofhidden prelative">
          {{item.title}}
      </div>
      </div>
    </div>

</template>

<script>
  export default {
    name: "news",
    data () {
        return {}
    },
    methods: {
      goDetail (path){
       //let path = `/cedu/notice/detail?id=${id}` 
       console.log(path)
        let routeData = this.$router.resolve({
            path
        })
        window.open(routeData.href, '_blank')
        //this.$router.push({path:'/cedu/notice/detail',query:{id:id}})
      },

    },
    computed: {
      more: function(){
        if(this.type == 'notice') //通知公告
          return '/train/notice'
        else if(this.type == 'policies') //政策法规
          return '/train/policies'
        else if(this.type == 'info')  //培训资讯
          return '/train/info'
        let path = `/cedu/notice/detail?id=${id}` 
        let routeData = this.$router.resolve({
            path
        })
        window.open(routeData.href, '_blank')
      },
    },
    props: [
      'type',
      'cont'
    ]
  }
</script>

<style scoped>
    .ndiv{width: 415px;height: 300px;}
    .est{border-bottom: 1px solid #ddd;}
    .est .tt{margin-bottom: -1px;}
    .est .blue{border-bottom: 1px solid #1787e0;}
    .sts{margin-bottom: -1px;border-bottom: 3px solid transparent;}
    .sts.active{font-weight: bold;border-color: #147ad8;}
    .sts.active .tc{color: #147ad8;}
    .nt{margin-bottom: 1px;height: 38px;line-height: 38px;}
    .nt:hover{font-weight: bold;color: #147ad8;}
</style>



// WEBPACK FOOTER //
// src/components/train/index/news.vue